import AxiosService from './AxiosService'; var as = AxiosService;
import { hashHistory } from 'react-router'
import LocalStorageService from './LocalStorageService'; var ls = LocalStorageService;

//store
import { store } from '../stores/configureStore';
import { push } from 'react-router-redux'

//action
import { toggleLoader } from '../actions';

//env
import * as ENV from '../environment/environment';

//var ProgressBar = require('react-progressbar.js')

var BASE_URL2 = ENV.BASE_URL;
var BASE_URL = BASE_URL2;

var DataService = {
  postLogin,
  postLogout,
  getAllRooms,
  getLockHome,
  postDevicesCheck,
  postNewCheckin,
  postExtendCheckin,
  postCheckout,
  getSomeRooms,
  getAlertSettings,
  getIntrusions,
  getIntrusionsCount,
  getIntrusionHistory,
  postAlertSettings,
  getRoomStatuses,
  getAllServices,
  getMyServices,
  postUpsertServices,
  getServiceRequests,
  getAllDevices,
  postMoveBackToHome,
  postProcessServiceRequests,
  postCreateTelephoneNumber,
  postCreateWifi,
  getAllTelephoneNumbers,
  getAllWifiList,
  postDeleteTelephoneNumber,
  postDeleteWifi,
  postEditTelephoneNumber,
  postEditWifi,
  getFoodMenu,
  postCreateFoodItem,
  postEditFoodItem,
  postDeleteFoodItem,
  postCreateUser,
  postEditUser,
  postDeleteUser,
  getAllUsers,
  postChangeUserPassword,
  getUnseenNotifCount,
  getSwitchesInRoom,
  postChangeUnseenCount,
  postChangeUnseenAlertCount,
  postSwitchEvent,
  postTurnOffRoom,
  postGetPowerData,
  postMoveLocks,
  postLockOtp,
  postLockHistory,
  postCardActionToLock,
  postGetEnergyData,
  postGetEnergyMeterData, // room level energy meter buckets
  postGetCheckinReport,
  getDevicesInHotel,
  getDevicesTypes,
  getDevicesInRoom,
  getUserDeviceAdditionalSettings,
  saveUserDeviceAdditionalSettings,
  getDeviceConfig,
  postCreateSwitches,
  getDeviceConfigKeys,
  postCreateButtonService,
  getAllButtonServices,
  postDeleteButtonService,
  postEditButtonService,
  postSaveServiceButtonPrefs,
  getPromotions,
  postCreatePromo,
  postEditPromo,
  postDeletePromo,
  postEditSwitch,
  getSearchBrands,
  getSearchProviders,
  getTestCodesets,
  postTriggerIr,
  postCreateRemote,
  getRoomRemotes,
  postEditRemote,
  postDeleteRemote,
  postCreateScene,
  postEditScene,
  postDeleteScene,
  getScenes,
  getRunningHours,
  postCreateSurveyForm,
  getFeedbackTemplates,
  getEnableStatus, // to check enable or disable
  getRoomsTokens, // to get all rooms with token
  postGenerateToken, // to generate token for a room,
  postEnableIntegration, // to enable or disable
  postCreateThermostat, // to register new thermostat
  getThermosList, // to get all thermostats present
  postDeleteThermostat, // to delete the thermostat
  postUpdateThermostat, // to edit particualr thermostat fields
  getAllPresentDevices, // to get all devices of hotel with room id,
  postCreateSchedule, // to create new schedule
  postListSchedules, // to get all the active schedules
  postDeleteSchedule, // to delete particular schedule
  postEditSchedule, // to edit a schedule,
  postSwitchHistory, // to get switch history for today
  postUpdatePassword, // to update the password
  getPartnerDetails,
  getFeedBackResponses, // to get all the responses for the particular feedback
  postPairLock,
  postGetPostEventActions,
  postAddPostEventActions
}

function getData(url, use_url2 = 0) {
  return new Promise((resolve, reject) => {
    let addr = BASE_URL + url;
    if (use_url2) {
      addr = BASE_URL2 + url;
    }
    store.dispatch(toggleLoader(true))
    as.getMe(addr)
      .then(data => {
        store.dispatch(toggleLoader(false));
        resolve(data.data);
      }).catch(err => {
        store.dispatch(toggleLoader(false))
        errHandler(err, reject);
      })
  })


}

function postData(url, data, use_url2 = 0) {
  return new Promise((resolve, reject) => {
    let addr = BASE_URL + url;
    if (use_url2) {
      addr = BASE_URL2 + url;
    }
    store.dispatch(toggleLoader(true))
    as.postMe(addr, data)
      .then(data => {
        store.dispatch(toggleLoader(false))
        resolve(data.data);
      }).catch(err => {
        store.dispatch(toggleLoader(false))
        errHandler(err, reject);
      })
  })

}

function logout() {
  // ls.setUserDetails({});
  // ls.setToken("");
  // hashHistory.push('#/login');
  ls.logout();
  store.dispatch(push('/login'))
}
function goTo403() {
  hashHistory.push('/misc/403');
}

function errHandler(err, reject) {
  if (!err.response) {
    let e = new CustomEvent('err_dialog', { detail: { message: 'There is Something wrong with our server, please try again later' } });
    window.dispatchEvent(e);
    return reject(err);
  }
  else {
    if (err.response.status == 401) {
      logout();
    }
    // if (err.response.status == 403) {
    // 	goTo403();
    // }
    else {
      let e = new CustomEvent('err_dialog', { detail: err.response.data });
      window.dispatchEvent(e);
    }
    return reject(err.response);
  }
}

//Get functions go here
function getAllRooms(hotel_id, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/guest_user/get_all?hotelId=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
// Get Lock Home
function getLockHome(hotel_id, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/guest_user/get_lockhome?hotelId=' + hotel_id)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  })
}

function getSomeRooms(hotel_id, limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/guest_user/get_all?hotelId=' + hotel_id + '&limit=' + limit + '&offset=' + offset)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getRoomStatuses(hotel_id, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/rooms/hotel_rooms?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getAlertSettings(hotel_id, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/hotels/get_settings_instrusion_alert?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getMyServices(hotel_id, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/services/get?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}


function getAllDevices(successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/user_devices/get_locks_in_hotel')
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function getAllServices(successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/services/get_services')
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getServiceRequests(hotel_id, limit, offset, successCallBack, errorCallBack, service_ids = 0) {
  let service_query = service_ids ? `&filter=${service_ids.join()}` : ''
  getData('hotel_user/api/v1/service_requests/get_range?hotel_id=' + hotel_id + '&limit=' + limit + '&offset=' + offset + service_query)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getPromotions(limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/promotions?' + 'limit=' + limit + '&offset=' + offset)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getAllTelephoneNumbers(hotel_id, limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/telephone_directory/get_all?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getAllWifiList(hotel_id, limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/wifi_management/get_all?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getFoodMenu(hotel_id, limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/food_items/get?hotel_id=' + hotel_id)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getAllUsers(hotel_id, limit, offset, successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/hotel_user/get_all_others_range?hotel_id=' + hotel_id + '&limit=' + limit + '&offset=' + offset)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getUnseenNotifCount(successCallBack, errorCallBack) {
  getData('hotel_user/api/v1/service_requests/get_unseen_request_count')
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getSwitchesInRoom(room_id, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/byroom?room=${room_id}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function getAllPresentDevices(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/byroom?all_room=1`)
    .then((data) => {
      successCallBack(data);
    })
    .catch((err) => {
      errorCallBack(err);
    }
    )
}

function getDevicesInHotel(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/get_devices`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getDevicesTypes(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/deviceTypes/get_all`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getDevicesInRoom(room_id, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/mydevices?room_id=${room_id}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function getUserDeviceAdditionalSettings(deviceId,hotel_id,askString, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/feature_support?ask=${askString}&userDevice=${deviceId}&hotel_id=${hotel_id}`).then(
    (data) => {
      successCallBack(data);
    }).catch((error) => {
      errorCallBack(error);
    });
}
function saveUserDeviceAdditionalSettings(featureName, featureAction, hotel_id, userDeviceID, successCallBack, errorCallBack) {
   getData(`hotel_user/api/v1/user_devices/toggle_feature?feature=${featureName}&action=${featureAction}&hotel_id=${hotel_id}&_id=${userDeviceID}`).then(
    (data) => {
      successCallBack(data);
    }).catch( (error) => {
      return errorCallBack(error);
    });
}
function getDeviceConfig(device_id, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/kiotdevice/device_config?device_id=${device_id}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getDeviceConfigKeys(UDid, room_id, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/user_devices/get_config_keys?device_id=${UDid}&room=${room_id}&appends=mqtt,wifi`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getAllButtonServices(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/button_service/get_all?skip=0&limit=0`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getSearchBrands(type, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/appliances?type=${type}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getSearchProviders(type, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/appliances/searchProviders?searchString=${type}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getTestCodesets(type, brand, successCallBack, errorCallBack) {
  let url = 'hotel_user/api/v1/appliances/test_codeset?type=' + type;
  if (type == "Set Top Box") {
    url += '&stb_provider=' + brand;
  }
  else {
    url += '&brand=' + brand;
  }
  getData(url)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getRoomRemotes(room, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/ir_appliances/myapps_by_room?room=${room}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function getScenes(room, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/scenes?room_id=${room}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getFeedbackTemplates(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/feedback/templates`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function getRunningHours(checkin,checkout,successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/guest_user/running_hours?checkin=${checkin}&checkout=${checkout}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function getRoomsTokens(limit, skip, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/token/rooms?offset=${skip}&limit=${limit}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function getThermosList(roomID, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/thermostat?room_id=${roomID}`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function getIntrusions(obj, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/hotels/get_intrusion_notifications?hotel_id=${obj.hotel_id}
  &limit=${obj.limit}&offset=${obj.offset}`)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  })
}

function getIntrusionsCount(obj, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/hotels/get_intrusion_notifications_unseen_count?hotel_id=${obj.hotel_id}`)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  })
}

function getIntrusionHistory(obj, successCallBack, errorCallBack) {
  let url = 'hotel_user/api/v1/hotels/get_intrusion_history?hotel_id=' + obj.hotel_id;
  if(obj.hotel_room_id){
    url += '&hotel_room_id=' + obj.hotel_room_id ;
  }
  if(obj.start_date){
    url += '&start_date=' + obj.start_date ;
  }
  if(obj.end_date){
    url += '&end_date=' + obj.end_date ;
  }
  url += '&limit='+obj.limit+'&offset='+obj.offset;
  getData(url)
   .then((data) => {
    successCallBack(data);
   }).catch((err) => {
    errorCallBack(err);
   })
}

function getEnableStatus(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/token/verify_api_integration`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    )
}

function getPartnerDetails(successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/partner/me`)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    )
}

function getFeedBackResponses(templateId, limit, skipCount, successCallBack, errorCallBack) {
  getData(`hotel_user/api/v1/feedback/responses?template_id=${templateId}&limit=${limit}&offset=${skipCount}`)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  });
}

//post Functions go here_________________________________________________________________________
//________________________________________________________________________________________________
function postLogin(obj, successCallBack, errorCallBack) {
  postData('authentication/hotel_user', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postLogout(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/logout', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postNewCheckin(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/guest_user/check_in', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
//Check Device Exists
function postDevicesCheck(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/guest_user/devicecheck', obj)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  })
}
function postMoveBackToHome(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/move_lock_back_to_home', obj)
  .then((data) => {
    successCallBack(data);
  }).catch((err) => {
    errorCallBack(err);
  })
}

function postAlertSettings(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotels/toggle_settings_hotel_rooms_intrusion_alerts', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postExtendCheckin(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/guest_user/extend', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCheckout(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/guest_user/check_out', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postUpsertServices(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/services/upsert', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postProcessServiceRequests(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/service_requests/process_request', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateTelephoneNumber(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/telephone_directory/create', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateWifi(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/wifi_management/create', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateSwitches(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/configure_switches',obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteTelephoneNumber(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/telephone_directory/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteWifi(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/wifi_management/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditTelephoneNumber(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/telephone_directory/edit', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditWifi(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/wifi_management/edit', obj)
     .then((data) => {
      successCallBack(data);
     }).catch((err) => {
      errorCallBack(err);
     })
}
function postCreateFoodItem(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/food_items/add_item', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditFoodItem(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/food_items/edit_item', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteFoodItem(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/food_items/delete_item', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateUser(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/create', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditUser(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/edit', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteUser(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postChangeUserPassword(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/set_password', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postChangeUnseenCount(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/service_requests/change_request_seen', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postChangeUnseenAlertCount(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotels/mark_alert_seen', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postSwitchEvent(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/deviceevents/switch', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postTurnOffRoom(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/deviceevents/turnoff_room', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postGetPowerData(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/power_data', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postMoveLocks(obj, successCallBack, errorCallBack) {
  postData( 'hotel_user/api/v1/user_devices/move_lock', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postLockHistory(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/deviceevents/lock/tp1', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postLockOtp(obj, successCallBack, errorCallBack) {
  postData( 'hotel_user/api/v1/deviceevents/lock/tp1', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCardActionToLock(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/deviceevents/lock/tp1', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postGetEnergyData(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/energy_data', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postGetEnergyMeterData(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/get_energy_data', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postGetCheckinReport(obj, successCallBack, errorCallBack) {
  postData(`hotel_user/api/v1/guest_user/analysis`, obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateButtonService(obj, successCallBack, errorCallBack) {
  postData(`hotel_user/api/v1/button_service/create`, obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteButtonService(obj, successCallBack, errorCallBack) {
  postData(`hotel_user/api/v1/button_service/delete`, obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditButtonService(obj, successCallBack, errorCallBack) {
  postData(`hotel_user/api/v1/button_service/edit`, obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postSaveServiceButtonPrefs(obj, successCallBack, errorCallBack) {
  postData(`hotel_user/api/v1/user_devices/assign_service`, obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreatePromo(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/promotions/new', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditPromo(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/promotions/edit', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeletePromo(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/promotions/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditSwitch(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/switch_appliances/update', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postTriggerIr(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/deviceevents/ircustom', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateRemote(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/ir_appliances/new', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditRemote(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/ir_appliances/myapps', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteRemote(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/ir_appliances/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateScene(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/scenes/new', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postEditScene(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/scenes/update', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postDeleteScene(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/scenes/delete', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}
function postCreateSurveyForm(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/feedback/new_template', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    })
}

function postEnableIntegration(object, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/token/oauth_client', object)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postGenerateToken(object, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/token/generate', object)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postCreateThermostat(object, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/thermostat/new', object)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postUpdateThermostat(object, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/thermostat/update', object)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postDeleteThermostat(object, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/thermostat/delete', object)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postCreateSchedule(schedule, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/gschedules/new', schedule)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postListSchedules(schedule, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/gschedules/list', schedule)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postDeleteSchedule(schedule, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/gschedules/delete', schedule)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postEditSchedule(schedule, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/gschedules/edit', schedule)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postSwitchHistory(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/switch_appliances/history', obj)
    .then((data) => {
      successCallBack(data);
    }).catch((err) => {
      errorCallBack(err);
    }
    );
}

function postUpdatePassword(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/hotel_user/update_password', obj)
    .then((data) => {
      successCallBack(data);
    })
    .catch((err) => {
      errorCallBack(err);
    }
    );
}

function postPairLock(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/lock/pair', obj)
    .then((data) => {
      successCallBack(data);
    })
    .catch((err) => {
      errorCallBack(err);
    }
    );
}


function postGetPostEventActions(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/post_event_actions', obj)
    .then((data) => {
      successCallBack(data);
    })
    .catch((err) => {
      errorCallBack(err);
    }
    );
}

function postAddPostEventActions(obj, successCallBack, errorCallBack) {
  postData('hotel_user/api/v1/user_devices/post_event_actions', obj)
    .then((data) => {
      successCallBack(data);
    })
    .catch((err) => {
      errorCallBack(err);
    }
    );
}
export default DataService;


// WEBPACK FOOTER //
// ./services/DataService.js